/**
 * Dialog sizes that never scroll sideways (DESIGN.md section 22): vertical
 * scroll only, a 1rem margin each side until the viewport passes the width
 * step plus 2rem (without `sm:w-[calc(100%-2rem)]` the dialog runs edge to
 * edge from 640px), and the content wraps to the dialog.
 *
 * Pick the step where the footer fits on one line in en and zh at 1280.
 */

/**
 * 768px: a dialog of data (a picker with two sections side by side, a variant
 * set-up, three sentence-length footer actions). The Fix design data dialog
 * and Base garments' Add variants.
 */
export const DESIGN_DATA_DIALOG_CLASS = 'max-h-[85vh] overflow-y-auto sm:w-[calc(100%-2rem)] sm:max-w-3xl';

/** 512px: a short form (a code, a name, one pick) with a two-button footer. */
export const FORM_DIALOG_CLASS = 'max-h-[85vh] overflow-y-auto sm:w-[calc(100%-2rem)] sm:max-w-lg';
